exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-exact-active,.router-link-exact-active:hover{background:#f3f5f9;color:#2a354f!important}#quesedeslice::-webkit-scrollbar{width:5px}#quesedeslice::-webkit-scrollbar-thumb{background:#ccc;border:0 none #fff;border-radius:50px}#quesedeslice::-webkit-scrollbar-track{background:#e7e7e7;border:0 none #fff;border-radius:7px}@media (max-width:767px){.dropdown_folders{left:unset!important}}[v-cloak]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0447f184","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/manage-bar.vue
// module id = 44
// module chunks = 0